import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { FormSelectChoice, InputSelectComponentProps } from '@sheerid/jslib';
import { InputSelectComponent } from '../../FormInputs/InputSelect/InputSelectComponent';

export const TeacherStatus = ({
    value,
    isErrored,
    options,
    onChange,
    placeholder = '',
    intl,
    onKeyDown = undefined,
}: InputSelectComponentProps) => (
    <div className="sid-field sid-teacher-status">
        <div className="sid-l-space-top-md" />
        <label htmlFor="sid-teacher-status">
            <div className="sid-field__label sid-field__label--required sid-teacher-status__label sid-l-space-btm-sm">
                <FormattedHTMLMessage
                    id="status"
                    defaultMessage="Status"
                />
            </div>
        </label>
        <InputSelectComponent
            fieldId="status"
            inputId="sid-teacher-status"
            isErrored={isErrored}
            options={options}
            onChange={(status: FormSelectChoice) => onChange(status)}
            onKeyDown={onKeyDown}
            value={value}
            placeholder={placeholder || intl.formatMessage({ id: 'statusPlaceholder', defaultMessage: 'Status*' })}
        />
        {
            isErrored ? (
                <div className="sid-field-error">
                    <FormattedHTMLMessage
                        id="errorId.invalidStatus"
                        defaultMessage="Invalid teacher status"
                    />
                </div>
            ) : null
        }
    </div>
);

export const TeacherStatusComponent = injectIntl(TeacherStatus);
